module.exports = __webpack_public_path__ + "static/img/pd_top_7.7be3fe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_7.jpg
// module id = gszc
// module chunks = 51